import { Paper, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useNavigate } from 'react-router-dom';
import MessageBar from './atoms/MessageBar';
import PageHeader from './molecules/PageHeader';
import Button from './atoms/Button';

const RegisterDeclaration = ({
  submitFormData,
  statusMsg,
  setStatusMsg,
  submissionComplete,
  loading,
}) => {
  const navigate = useNavigate();
  let msg = '';

  const handleSubmission = e => {
    e.preventDefault();
    if (
      document.getElementById('cb1').checked &&
      document.getElementById('cb2').checked
    ) {
      submitFormData(e);
    } else {
      setStatusMsg('Please acknowledge both statements before proceeding');
    }
  };

  return (
    <div>
      <PageHeader>Declaration</PageHeader>
      <Paper elevation={5} sx={{ padding: '20px' }}>
        <div>
          By submitting this registration form and providing my personal data to
          the Church of Our Lady of Perpetual Succour (OLPS), i consent to the
          Church’s collection, use and disclosure of my personal data in
          accordance with the policy statement which can be viewed at&nbsp;
          <a href='https://www.catholic.sg/pdpa-policy/' target='_new'>
            https://www.catholic.sg/pdpa-policy
          </a>
          , for the purpose of enrolling my child/ward in the catechetical
          formation sessions held at OLPS.
        </div>
        <div>
          <FormControlLabel
            required
            control={<Checkbox id='cb1' inputProps={{ 'data-cy': 'cb1' }} />}
            label='I agree'
          />
        </div>
        <div className='spacer'></div>
        <div>
          I hereby declare that all the information provided within this
          registration form is true and correct.
        </div>
        <div>
          <FormControlLabel
            required
            control={<Checkbox id='cb2' inputProps={{ 'data-cy': 'cb2' }} />}
            label='Yes'
          />
        </div>
      </Paper>

      <div className='center'>
        <div className='spacer'></div>
        <MessageBar msg={statusMsg} testid='declaration-msg' />
      </div>

      <div className='spacer'></div>

      <div className='text-right'>
        {!submissionComplete && (
          <Button
            callback={handleSubmission}
            testid='submitButton'
            loading={loading}
          >
            Submit Registration
          </Button>
        )}
      </div>
    </div>
  );
};

export default RegisterDeclaration;
